document.querySelectorAll('p iframe').forEach((iframe) => {
	const paragraph = iframe.parentElement;

	if (!paragraph) {
		return;
	}

	// Turn the paragraph into a 16:9 wrapper around the embedded iframe.
	paragraph.style.position = 'relative';
	paragraph.style.paddingBottom = '56.25%';
	paragraph.style.height = '0';
	paragraph.style.overflow = 'hidden';

	// Fill the wrapper so the iframe scales with the available width.
	iframe.style.position = 'absolute';
	iframe.style.inset = '0';
	iframe.style.width = '100%';
	iframe.style.height = '100%';
});
